import React from "react";
import { Modal, Form, Input } from "antd";

export default function LoginModal({ open, onCancel, onLogin, loading = false }) {
  const [form] = Form.useForm();

  const handleOk = async () => {
    const values = await form.validateFields();
    onLogin?.(values);
  };

  // Reset form every time the modal closes so stale credentials are cleared
  const handleAfterClose = () => {
    form.resetFields();
  };

  return (
    <Modal
      title="Login"
      open={open}
      width={420}
      centered
      maskClosable={false}
      destroyOnClose
      afterClose={handleAfterClose}
      onCancel={() => { form.resetFields(); onCancel?.(); }}
      onOk={handleOk}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="username" label="Username" rules={[{ required: true }]}>
          <Input autoComplete="username" autoFocus />
        </Form.Item>
        <Form.Item name="password" label="Password" rules={[{ required: true }]}>
          <Input.Password autoComplete="current-password" />
        </Form.Item>
      </Form>
    </Modal>
  );
}